import { render, staticRenderFns } from "./OrganizationContactSecurityRolesManager.vue?vue&type=template&id=3f3f8d4e&"
import script from "./OrganizationContactSecurityRolesManager.vue?vue&type=script&lang=js&"
export * from "./OrganizationContactSecurityRolesManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports